/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetReservableSpaceStatisticsPathParameters } from 'api/actions/get-reservable-space-statistics/get-reservable-space-statistics-path-parameters';
import { GetReservableSpaceStatisticsResponse } from 'api/actions/get-reservable-space-statistics/get-reservable-space-statistics-response';

type GetReservableSpaceStatisticsQueryParameters = Record<string, any>;

/**
 * The path of the GetReservableSpaceStatistics action.
 */
export const getReservableSpaceStatisticsActionPath = new SweetPath<keyof GetReservableSpaceStatisticsPathParameters>(
  '/admin/custom/reservable-spaces/{spaceId}/statistics',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetReservableSpaceStatistics actions.
 */
export default function createGetReservableSpaceStatisticsAction(axios: AxiosInstance) {
  return function getReservableSpaceStatisticsAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetReservableSpaceStatisticsPathParameters;
    query?: GetReservableSpaceStatisticsQueryParameters;
  }) {
    const path = getReservableSpaceStatisticsActionPath.insert(parameters);

    return axios.get<GetReservableSpaceStatisticsResponse, GetReservableSpaceStatisticsResponse>(path, {
      params: query,
      headers,
    });
  };
}
